export default __webpack_public_path__ + "static/media/ConventionalSeat.8cf6b198.svg";